<script lang="ts">
  import { Tooltip } from '$lib/components/tooltip';

  /** Default: `''` */
  export let font = '';
  /** Default: `(v) => v` */
  export let onCopy = (value: string) => value;
  /** Required */
  export let value: string;
  /** Default: `span` */
  export let valueTag: 'span' | 'p' = 'span';

  const textBackground = 'hover:bg-primary-200-700-token active:bg-primary-300-600-token';

  let copied: boolean;
  let timeout: NodeJS.Timeout;

  $: tooltipDisplay = copied ? 'block' : 'collapse';

  /**
   * Copy text to clipboard and send visual feedback
   * using a tooltip
   */
  function onClick() {
    clearTimeout(timeout);
    copied = true;

    const handledText = onCopy(value);
    navigator.clipboard.writeText(handledText);

    timeout = setTimeout(() => (copied = false), 2000);
  }
</script>

<Tooltip display={tooltipDisplay} event="click" background="bg-primary-200-700-token" cursor="cursor-copy">
  <svelte:fragment slot="tooltip">
    <p class="text-xs font-medium">Copiado!</p>
  </svelte:fragment>

  {#if valueTag === 'span'}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <span class="{textBackground} {font}" on:click={onClick}>{value}</span>
  {:else}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
    <p class="{textBackground} {font}" on:click={onClick}>{value}</p>
  {/if}
</Tooltip>
